import React, { useState } from 'react';
import comunicateImage from '../assets/images/comunicate.png';

// --- INLINE SVG ICONS (Hatasız ve Hızlı) ---
const Icons = {
  User: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  AtSign: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="12" cy="12" r="4" />
      <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94" />
    </svg>
  ),
  MessageCircle: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    </svg>
  ),
  Send: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  Mail: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  HelpCircle: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  Heart: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" className={className}>
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  ),
  Star: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" className={className}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  )
};

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('🎉 Süper! Mesajın bize ulaştı! Çok yakında seninle iletişime geçeceğiz! 🌟');
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="min-h-screen bg-[#FDFDFC] font-sans relative overflow-hidden">

      {/* --- BACKGROUND BLOBS --- */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute top-[-5%] right-[-5%] w-[500px] h-[500px] bg-blue-100/40 rounded-full blur-[100px] animate-pulse" />
        <div className="absolute bottom-[10%] left-[-10%] w-[600px] h-[600px] bg-purple-100/40 rounded-full blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 py-12 md:py-20 relative z-10">

        {/* --- HEADER --- */}
        <div className="text-center max-w-5xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-white border border-gray-100 shadow-sm rounded-full px-5 py-2 mb-6 transform hover:scale-105 transition-transform cursor-default">
            <span className="text-2xl animate-wave">👋</span>
            <span className="text-sm font-bold text-gray-500 tracking-wide uppercase">Bize Ulaşın</span>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-6">
            {/* Sol: Başlık ve Açıklama */}
            <div className="text-center lg:text-left">
              <h1 className="text-5xl md:text-7xl font-black text-gray-900 tracking-tight leading-tight mb-6">
                Merhaba De! <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500">Seni Dinliyoruz</span>
              </h1>

              <p className="text-xl text-gray-600 font-medium leading-relaxed">
                Soruların mı var? Yoksa sadece "Selam" mı demek istiyorsun?
                Aşağıdaki formu doldur, hemen cevaplayalım! 🚀
              </p>
            </div>

            {/* Sağ: İletişim Görseli */}
            <div className="relative group">
              <div className="absolute inset-4 bg-gradient-to-tr from-blue-300 to-purple-300 rounded-[3rem] blur-2xl opacity-30 group-hover:opacity-50 transition-opacity duration-500" />
              <img
                src={comunicateImage}
                alt="Mucittin İletişim"
                className="relative w-full max-w-md mx-auto rounded-[3rem] shadow-2xl border-4 border-white transform transition-transform duration-500 group-hover:rotate-2 group-hover:scale-[1.05]"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start max-w-7xl mx-auto">

          {/* --- LEFT COLUMN: FORM --- */}
          <div className="lg:col-span-7">
            <div className="bg-white rounded-[2.5rem] p-8 md:p-10 shadow-xl shadow-purple-100/50 border-4 border-white ring-1 ring-purple-50">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-14 h-14 bg-yellow-100 text-yellow-600 rounded-2xl flex items-center justify-center transform -rotate-6 shadow-sm">
                  <span className="text-2xl">✍️</span>
                </div>
                <div>
                  <h2 className="text-2xl font-black text-gray-900">Mesajını Yaz</h2>
                  <p className="text-gray-500 font-medium">Bize her şeyi sorabilirsin!</p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">

                {/* Name Input */}
                <div className="space-y-2 group">
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-700 uppercase tracking-wider ml-1">
                    <Icons.User className="w-4 h-4 text-purple-400" />
                    Adın Ne?
                  </label>
                  <input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Örn: Ali, Ayşe..."
                    className="w-full bg-gray-50 hover:bg-white focus:bg-white text-gray-800 font-bold text-lg rounded-2xl px-6 py-4 outline-none border-2 border-transparent focus:border-purple-300 focus:ring-4 focus:ring-purple-100 transition-all placeholder:text-gray-400 placeholder:font-normal"
                    required
                  />
                </div>

                {/* Email Input */}
                <div className="space-y-2 group">
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-700 uppercase tracking-wider ml-1">
                    <Icons.AtSign className="w-4 h-4 text-pink-400" />
                    E-posta Adresi
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="ornek@email.com (Anne veya babanınki olabilir)"
                    className="w-full bg-gray-50 hover:bg-white focus:bg-white text-gray-800 font-bold text-lg rounded-2xl px-6 py-4 outline-none border-2 border-transparent focus:border-pink-300 focus:ring-4 focus:ring-pink-100 transition-all placeholder:text-gray-400 placeholder:font-normal"
                    required
                  />
                </div>

                {/* Message Input */}
                <div className="space-y-2 group">
                  <label className="flex items-center gap-2 text-sm font-bold text-gray-700 uppercase tracking-wider ml-1">
                    <Icons.MessageCircle className="w-4 h-4 text-blue-400" />
                    Mesajın
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    placeholder="Aklındakileri buraya dökebilirsin... 🌈"
                    className="w-full bg-gray-50 hover:bg-white focus:bg-white text-gray-800 font-bold text-lg rounded-2xl px-6 py-4 outline-none border-2 border-transparent focus:border-blue-300 focus:ring-4 focus:ring-blue-100 transition-all placeholder:text-gray-400 placeholder:font-normal resize-none"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="w-full group relative overflow-hidden bg-gray-900 hover:bg-purple-600 text-white font-black text-xl py-5 rounded-2xl shadow-xl hover:shadow-purple-500/30 transition-all duration-300 transform hover:-translate-y-1 active:scale-95"
                >
                  <div className="relative z-10 flex items-center justify-center gap-3">
                    <span>Mesajı Gönder</span>
                    <Icons.Send className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </div>
                </button>
              </form>
            </div>
          </div>

          {/* --- RIGHT COLUMN: INFO CARDS --- */}
          <div className="lg:col-span-5 space-y-6">

            {/* Email Card */}
            <div className="bg-white rounded-[2rem] p-6 border-2 border-purple-100 hover:border-purple-300 transition-colors group cursor-default shadow-sm hover:shadow-md">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-purple-100 text-purple-600 rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-transform">
                  <Icons.Mail className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-xl font-black text-gray-900 mb-1">E-posta Yaz 📧</h3>
                  <p className="text-gray-500 font-medium mb-2 leading-tight">Anne veya babanla birlikte mail atabilirsin.</p>
                  <a href="mailto:info@mucittin.com" className="text-purple-600 font-bold text-lg hover:underline decoration-2 underline-offset-2">info@mucittin.com</a>
                </div>
              </div>
            </div>

            {/* FAQ Card */}
            <div className="bg-white rounded-[2rem] p-6 border-2 border-blue-100 hover:border-blue-300 transition-colors group cursor-default shadow-sm hover:shadow-md">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                  <Icons.HelpCircle className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-black text-gray-900">Merak Edilenler 🧐</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-center gap-3 p-3 bg-blue-50/50 rounded-xl border border-blue-100">
                  <span className="text-xl">🎮</span>
                  <span className="text-gray-700 font-medium text-sm">Oyunlar ücretsiz mi? <span className="text-blue-600 font-bold ml-1">Evet!</span></span>
                </li>
                <li className="flex items-center gap-3 p-3 bg-blue-50/50 rounded-xl border border-blue-100">
                  <span className="text-xl">📱</span>
                  <span className="text-gray-700 font-medium text-sm">Tablette açılır mı? <span className="text-blue-600 font-bold ml-1">Çalışır!</span></span>
                </li>
              </ul>
            </div>

            {/* Community Card */}
            <div className="bg-gradient-to-br from-pink-500 to-orange-500 rounded-[2rem] p-8 text-white text-center relative overflow-hidden shadow-lg shadow-pink-500/20 group hover:scale-[1.02] transition-transform duration-300">
              {/* Pattern */}
              <div className="absolute top-0 left-0 w-full h-full opacity-10" style={{ backgroundImage: 'radial-gradient(circle, white 2px, transparent 2px)', backgroundSize: '16px 16px' }}></div>

              <div className="relative z-10">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
                  <Icons.Heart className="w-8 h-8 text-white" />
                </div>

                <h3 className="text-2xl font-black mb-2">Bizi Seviyor Musun?</h3>
                <p className="font-medium opacity-90 mb-6 leading-relaxed">
                  Arkadaşlarına bizden bahset, kocaman bir aile olalım! 🎈
                </p>

                <div className="flex justify-center gap-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Icons.Star key={star} className="w-6 h-6 text-yellow-300 drop-shadow-md transform hover:scale-125 transition-transform cursor-pointer" />
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};